(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-legal-guarantee-dialog"] && !Shopify.designMode) return;
  try {
    if (!window.mcLegalNoticeBound) {
    window.mcLegalNoticeBound = true;
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-mc-legal-open]');
      if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        const dialog = document.getElementById('mc-legal-notice');
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.showModal();
        }
      }
      const closer = event.target.closest('[data-mc-legal-close]');
      if (closer) closer.closest('dialog').close();
      if (event.target.id === 'mc-legal-notice') {
        const bounds = event.target.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
